import type { TOC } from '@ember/component/template-only';

import styles from './skeleton.module.css';

interface HotelNetRevenueSkeletonSignature {
  Args: {};
  Element: HTMLDivElement;
}

const HotelNetRevenueSkeleton = <template>
  <div class={{styles.pulse}} ...attributes></div>
</template> satisfies TOC<HotelNetRevenueSkeletonSignature>;

export default HotelNetRevenueSkeleton;
